import React, { useLayoutEffect, useRef, useCallback } from 'react';
import ReactDOM from 'react-dom';
import cmsUtils from '../../utils/cmsUtils';
import utils from '../../../utils';

import { useRouter } from '../../../components';

import { handleElementLink } from '../../../components';
import env from '../../../env';
import { structureTable } from './structureTable';

//import { Document, Page } from 'react-pdf'
//import { Document, Page } from 'react-pdf/dist/entry.webpack';

function getCellContent(cell) {
  return cell ? cell.innerHTML : "";
}

function restructureResponsiveTables(container) {
  const isMobile = utils.site.isMobile();

  container.querySelectorAll("table.cms-table, table.table-row-header, table.table-col-header").forEach((table) => {
    const isRowHeader = table.classList.contains("table-row-header");
    const wrapper = table.parentElement.querySelector('.responsive-table-wrapper[data-source-table]');

    if (!isMobile) {
      table.style.display = "";
      if (wrapper) wrapper.style.display = "none";
      return;
    }

    table.style.display = "none";

    if (wrapper) {
      wrapper.style.display = "";
      return;
    }

    const rows = Array.from(table.querySelectorAll("tr"));
    if (rows.length < 2) return;

    const newWrapper = document.createElement("div");
    newWrapper.className = "responsive-table-wrapper";
    newWrapper.setAttribute("data-source-table", "true");

    if (isRowHeader) {
      const headerCells = Array.from(rows[0].querySelectorAll("th, td"));
      const dataRows = rows.slice(1);

      dataRows.forEach((row) => {
        const cells = Array.from(row.querySelectorAll("th, td"));
        const miniTable = document.createElement("table");
        miniTable.className = "responsive-table responsive-table--row-header";
        const tbody = document.createElement("tbody");

        headerCells.forEach((headerCell, idx) => {
          const tr = document.createElement("tr");
          const th = document.createElement("th");
          th.innerHTML = getCellContent(headerCell);
          const td = document.createElement("td");
          td.innerHTML = getCellContent(cells[idx]);
          tr.appendChild(th);
          tr.appendChild(td);
          tbody.appendChild(tr);
        });

        miniTable.appendChild(tbody);
        newWrapper.appendChild(miniTable);
      });
    } else {
      const headerCells = rows.map((row) => {
        const cells = row.querySelectorAll("th, td");
        return cells.length > 0 ? cells[0] : null;
      });

      const colCount = rows[0] ? rows[0].querySelectorAll("th, td").length : 0;

      for (let col = 1; col < colCount; col++) {
        const miniTable = document.createElement("table");
        miniTable.className = "responsive-table responsive-table--col-header";
        const tbody = document.createElement("tbody");

        rows.forEach((row, rowIdx) => {
          const cells = Array.from(row.querySelectorAll("th, td"));
          const tr = document.createElement("tr");
          const th = document.createElement("th");
          th.innerHTML = getCellContent(headerCells[rowIdx]);
          const td = document.createElement("td");
          td.innerHTML = getCellContent(cells[col]);
          tr.appendChild(th);
          tr.appendChild(td);
          tbody.appendChild(tr);
        });

        miniTable.appendChild(tbody);
        newWrapper.appendChild(miniTable);
      }
    }

    table.parentNode.insertBefore(newWrapper, table.nextSibling);
  });
}

function debugTableState(stage, root, cmsOption) {
  if (typeof window === 'undefined') return;

  const tables = root
    ? Array.from(root.querySelectorAll('table')).map((table) => ({
      className: table.className || '',
      rowCount: table.querySelectorAll('tr').length
    }))
    : [];

  const wrappers = root ? root.querySelectorAll('.responsive-table-wrapper').length : 0;
  const payload = {
    version: 'html-table-debug-v1',
    stage,
    isCmsEdit: !!cmsOption?.isCmsEdit,
    isMobile: utils.site.isMobile(),
    tableCount: tables.length,
    wrappers,
    tables
  };

  window.__TABLE_DEBUG__ = payload;
  console.log('[table-debug]', payload);
}

export function Html(props) {
  const ver = env.ver;
  const item = props.item;
  //const subItems = item.items || [];
  const cmsOption = props.cmsOption || {};
  const { history } = useRouter();
  //const [ pdfViewPath, setPdfViewPath ] = React.useState(null)
  //console.log('item', item, cmsOption);

  const year = (new Date()).getFullYear();
  let content = cmsOption.isCmsEdit? 
    cmsUtils.payload(item, 'Content'): 
    cmsUtils.payload(item, 'Content')
      .replace(/__year__/g, year)
      .replace("__version__", "<a href = '/app' class = 'app_version'> PWA "+ ver +"</a>");

    content = content
      .replace(
        /class="aos_effect_up"/gi,
        `class="aos_effect_up" data-aos="fade-up"`
      )
      .replace(
        /class="aos_effect_down"/gi,
        `class="aos_effect_down" data-aos="fade-down"`
      )
      .replace(
        /class="aos_effect_left"/gi,
        `class="aos_effect_left" data-aos="fade-left"`
      )
      .replace(
        /class="aos_effect_right"/gi,
        `class="aos_effect_right" data-aos="fade-right"`
      );


  const cssClass = utils.classNames('cms_item', 'htmlPanel', cmsOption.isCmsEdit && 'html', item.cssClass || item.anchorName || '');

  //let itemElt = (<div dangerouslySetInnerHTML={{ __html: content }}></div>);

  function handleClick(e) {
    
    let target = "";
    if(e.target.closest('a')){
      target = e.target.closest('a').getAttribute('target');
    }
    const processed = (target === "_blank" ? handleElementLink(e.target, null) : handleElementLink(e.target));
    //const link = utils.url.getLinkFromElement(e.target);
    //console.log('clicked', e, e.target, processed);
    
    if (processed.handled) {
      e.preventDefault();
      e.stopPropagation();
    } else if (processed.linkInfo && processed.linkInfo.type === 'internal') {
      e.preventDefault();
      e.stopPropagation();
      history.push(processed.linkInfo.url)
    } else {
      //e.preventDefault();
      //e.stopPropagation();
      // setPdfViewPath(utils.site.resourcePath(link))

      if(e.target.closest('a')){
        let href = e.target.closest('a').getAttribute('href') + "";
          if(href.indexOf('#') !== -1){
          let _href = href.split('#');
          console.log("_href", _href);
          let el = document.querySelector('section[data-cms-item-anchor="' + _href[1] + '"]');
          let anchorStatus = el.getAttribute('data-anchor-status');
          if(anchorStatus === "collapse"){
            el.setAttribute('data-anchor-status', 'expand');
            el.classList.add("expand");
          }
          else{
            el.setAttribute('data-anchor-status', 'collapse');
            el.classList.remove("expand");
          }
          e.preventDefault();
          e.stopPropagation(); 
        }
      }

    }
  }
  //console.log(pdfViewPath)
  const pdfView = 
    // pdfViewPath ? 
    // <Document file={pdfViewPath}><Page pageIndex={1}/></Document> : 
    null;

  const htmlBlock = useRef(null);
  // function iframeSizer() {
  //   //console.log('iframesizer')
  //   let iframesContainer = htmlBlock.current.querySelectorAll('iframe.youtube, .ytvideo iframe');
  //   //console.log('iframesizer', iframesContainer)
  //   if (iframesContainer && iframesContainer.length) {
  //     iframesContainer.forEach(element => {
  //       let height = (element.parentElement.offsetWidth * 9) / 16
  //       //console.log(height, element.parentElement.offsetWidth)
  //       element.style.height = height + 'px';
  //     });
  //   }
  // }


  useLayoutEffect(() => {
    //console.log(cmsOption.isCmsEdit)
    if (!cmsOption.isCmsEdit || cmsOption.cmsViewMode === 'viewonly') {
      replaceEmbedCodes(htmlBlock.current, cmsOption);
    }
      
    const buttons = htmlBlock.current.querySelectorAll('.button');
    for (let i = 0; buttons && i < buttons.length; i++) {
      restructureButton(buttons[i])
    }

    structureTable(htmlBlock.current);
    debugTableState('after-structure', htmlBlock.current, cmsOption);

    if (!cmsOption.isCmsEdit) {
      restructureResponsiveTables(htmlBlock.current);
      debugTableState('after-responsive', htmlBlock.current, cmsOption);
    }

    window.__RUN_TABLE_RESPONSIVE__ = () => {
      structureTable(htmlBlock.current);
      restructureResponsiveTables(htmlBlock.current);
      debugTableState('manual-trigger', htmlBlock.current, cmsOption);
    };

    // iframeSizer();
    // window.addEventListener('resize', iframeSizer)
    // return (): void => {
    //   window.removeEventListener('resize', iframeSizer)
    // }

  }, [cmsOption])

  const handleResize = useCallback(() => {
    if (htmlBlock.current && !cmsOption.isCmsEdit) {
      debugTableState('resize-before', htmlBlock.current, cmsOption);
      structureTable(htmlBlock.current);
      restructureResponsiveTables(htmlBlock.current);
      debugTableState('resize-after', htmlBlock.current, cmsOption);
    }
  }, [cmsOption]);

  React.useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [handleResize]);

  return (
    <>
    <div ref={htmlBlock} className={cssClass} data-cms-html="true"
      data-cms-item-id={cmsOption.isCmsEdit && item.itemId} id={item.anchorName}
      dangerouslySetInnerHTML={{ __html: content }} onClick={(e) => handleClick(e)}></div>
    {pdfView}
    </>
  )
}


function restructureButton(el) {
  if (!el.querySelector('span')) {
    const span = document.createElement('span');
    span.innerHTML = el.innerHTML;
    el.innerHTML = '';
    el.appendChild(span);
  }
}


function replaceEmbedCodes(block, cmsOption) {
  const embedDataList = cmsOption?.pageData?.embedDataList;
  const embedCodes = block.querySelectorAll('[data-embed-jaba]')
  embedCodes.forEach(embed => {
    const id = embed.getAttribute("data-embed-jaba");
    const found = utils.array.find(embedDataList, x => x.id === id);
    if (found){
      //console.log(found)
      ReactDOM.render(<div className={`codeType_${found.codeType}`} dangerouslySetInnerHTML={{ __html: found.code }}></div>, embed);
    }
  })
  //console.log(embedCodes, embedDataList)
}

